import React, { useEffect } from "react";
import { useAuthenticationConfiguration } from "./Configuration";
import useAuthenticationStore from "./Store";
import { AuthenticationViews } from "./types";
import { useNavigate } from "react-router-dom";
import AddPasskey from "./AddPasskey";

const AddPasskeyContainer: React.FC = () => {
    const configuration = useAuthenticationConfiguration();
    const { state, addPasskey } = useAuthenticationStore();
    const { serverError, isLoading } = state;
    const navigate = useNavigate();

    useEffect(() => {
        if (!configuration.passkeyServerBaseUrl) {
            navigate("../" + AuthenticationViews.login);
        }
    }, []);

    return <AddPasskey serverError={serverError} isLoading={isLoading} addPasskey={addPasskey} />;
};

export default AddPasskeyContainer;
